import * as React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { UserContext } from 'contexts/UserContext';
import { SentryBoundary } from 'common/SentryBoundary';
import { configureSentry } from 'services/configureSentry';
import GlobalStyle from 'styles';
import { ProtectedRoute } from './ProtectedRoute';

const Welcome = React.lazy(() => import('pages/Welcome'));
const Admin = React.lazy(() => import('pages/Admin'));
const WaterUsage = React.lazy(() => import('pages/WaterUsage'));
const WaterMeterReadingInitial = React.lazy(() => import('pages/WaterMeterReadingInitial'));
const WaterMeterReadingFinal = React.lazy(() => import('pages/WaterMeterReadingFinal'));
const WaterMeterReadingPassedOn = React.lazy(() => import('pages/WaterMeterReadingPassedOn'));
const WaterMeterReadingError = React.lazy(() => import('pages/WaterMeterReadingError'));
const Household = React.lazy(() => import('pages/Household'));
const Questions = React.lazy(() => import('pages/Questions'));
const PossessionsPage = React.lazy(() => import('pages/PossessionsPage'));
const Results = React.lazy(() => import('pages/Results'));

configureSentry();

const App: React.FC = () => {
  const { user } = React.useContext(UserContext);

  return (
    <main>
      <GlobalStyle />
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <SentryBoundary>
        <React.Suspense fallback={<div />}>
          <Routes>
            <Route index path="/" element={<Welcome />} />
            <Route path="/admin" element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            } />
            <Route path="/meterstand-einde/:userId" element={<WaterMeterReadingFinal />} />
            <Route path="/meterstand-doorgegeven" element={<WaterMeterReadingPassedOn />} />
            <Route path="/meterstand-afgerond" element={<WaterMeterReadingError />} />
            <Route path="/meterstand-begin" element={<WaterMeterReadingInitial />} />
            {user.id && (
              <>
                <Route path="/verbruik" element={<WaterUsage />} />
                <Route path="/huishouden" element={<Household />} />
                <Route path="/categorie/*" element={<Questions />} />
                <Route path="/bezittingen" element={<PossessionsPage />} />
                <Route path="/resultaat" element={<Results />} />
              </>
            )}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>

        </React.Suspense>
      </SentryBoundary>
    </main>
  );
};

export default App;
